"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../dsl/front");
const services_1 = require("../../services");
const ui_1 = require("../_abstract/ui");
/**
 * Component capable of rendering the `PaginationModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let PaginationModuleUi = class PaginationModuleUi extends ui_1.AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * @see BootstrapPaginationProps.currentPage
         */
        this.currentPage = 1;
        /**
         * Description of the associated related list.
         */
        this.listDescription = null;
        /**
         * Page number's query param name.
         */
        this.pageParamName = 'page';
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const { list } = this.module.content;
        if (!services_1.isRelated(list))
            return;
        try {
            this.listDescription = await this.relatedService.describe(list);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    /**
     * Handles the `@change` event on the `<BootstrapPagination>`.
     */
    onPageChange(page) {
        this.currentPage = page;
        this.$router.push({ query: { [this.pageParamName]: `${page}` } });
    }
    /**
     * @see BootstrapPaginationProps.showDirectionButtons
     */
    get showDirectionButtons() {
        return this.module.content.showDirectionButtons;
    }
    /**
     * @see BootstrapPaginationProps.totalPages
     */
    get totalPages() {
        if (this.listDescription === null || typeof this.listDescription.totalItems !== 'number') {
            return 0;
        }
        return Math.ceil(this.listDescription.totalItems / this.module.content.perPage);
    }
    /**
     * @see BootstrapPaginationProps.totalVisible
     */
    get totalVisible() {
        return this.module.content.totalVisible;
    }
    /**
     * Determines whether the `page` parameter exists in the URL query.
     */
    get hasPageInQuery() {
        return typeof this.pageFromQuery === 'string';
    }
    /**
     * `page` parameter from the URL query.
     */
    get pageFromQuery() {
        return this.$route.query[this.pageParamName];
    }
    /**
     * Reads the `page` param from the URL query and if it exists,
     * uses it as a starting point.
     */
    readPageFromQuery() {
        if (!this.hasPageInQuery) {
            return;
        }
        this.currentPage = parseInt(this.pageFromQuery);
    }
};
PaginationModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'PaginationModuleUi',
        components: { BootstrapPagination: front_1.BootstrapPagination },
        async created() {
            this.readPageFromQuery();
            await this.fetchRelated();
        },
        template: `
    <section class="pagination-module module"
             :class="[debugClass, loadingClass, versionClass]">
    <BootstrapPagination v-bind="{ currentPage, showDirectionButtons, totalPages, totalVisible }"
                         :link="{ target: $route, param: pageParamName }"
                         @change="onPageChange"/>
    </section>
  `
    })
], PaginationModuleUi);
exports.PaginationModuleUi = PaginationModuleUi;
//# sourceMappingURL=Pagination.ui.js.map